import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const OurWorksPage = () => {
  const projects = [
    {
      title: 'Modern Bathroom Renovation',
      location: 'Killarney, Kerry',
      category: 'Bathroom',
      image: 'https://static.readdy.ai/image/2b8febc409be403949093d91f25c447f/6f949348d09752f8397ec47ef880f9ef.jpeg',
    },
    {
      title: 'Underfloor Heating Installation',
      location: 'Tralee, Kerry',
      category: 'Heating',
      image: 'https://static.readdy.ai/image/2b8febc409be403949093d91f25c447f/81ca38139e9c9a999738698c8797aa55.jpeg',
    },
    {
      title: 'Boiler System Replacement',
      location: 'Kenmare, Kerry',
      category: 'Heating',
      image: 'https://static.readdy.ai/image/2b8febc409be403949093d91f25c447f/300a178fcc1cf09e732bf9fa881dc904.jpeg',
    },
    {
      title: 'Luxury Bathroom Suite',
      location: 'Killarney, Kerry',
      category: 'Bathroom',
      image: 'https://public.readdy.ai/ai/img_res/c4a96d3e2de1da6e1d8bda5e5568af8c.jpg',
    },
    {
      title: 'Radiator Upgrade Project',
      location: 'Dingle, Kerry',
      category: 'Heating',
      image: 'https://readdy.ai/api/search-image?query=modern%20radiator%20installation%20in%20contemporary%20home%20sleek%20vertical%20radiator%20design%20clean%20wall%20mounting%20professional%20heating%20upgrade%20light%20neutral%20interior&width=800&height=600&seq=work-005&orientation=landscape',
    },
    {
      title: 'Heat Pump Installation',
      location: 'Killarney, Kerry',
      category: 'Heating',
      image: 'https://readdy.ai/api/search-image?query=heat%20pump%20system%20installation%20outdoor%20unit%20mounted%20on%20wall%20modern%20energy%20efficient%20heating%20solution%20professional%20setup%20clean%20installation%20light%20background&width=800&height=600&seq=work-006&orientation=landscape',
    },
    {
      title: 'Commercial Plumbing Project',
      location: 'Tralee, Kerry',
      category: 'Plumbing',
      image: 'https://static.readdy.ai/image/2b8febc409be403949093d91f25c447f/b4546c0465242e2a7f68df628d6c37a9.jpeg',
    },
    {
      title: 'Bathroom Repair & Upgrade',
      location: 'Kenmare, Kerry',
      category: 'Bathroom',
      image: 'https://readdy.ai/api/search-image?query=bathroom%20repair%20and%20upgrade%20project%20new%20toilet%20washbasin%20and%20shower%20installation%20fresh%20white%20tiles%20modern%20fixtures%20professional%20renovation%20light%20clean%20design&width=800&height=600&seq=work-008&orientation=landscape',
    },
    {
      title: 'Central Heating System',
      location: 'Killarney, Kerry',
      category: 'Heating',
      image: 'https://readdy.ai/api/search-image?query=central%20heating%20system%20installation%20with%20multiple%20radiators%20and%20boiler%20complete%20home%20heating%20solution%20professional%20plumbing%20work%20organized%20pipes%20light%20neutral%20setting&width=800&height=600&seq=work-009&orientation=landscape',
    },
    {
      title: 'Professional Plumbing Installation',
      location: 'Killarney, Kerry',
      category: 'Plumbing',
      image: 'https://static.readdy.ai/image/2b8febc409be403949093d91f25c447f/5af3caa5e980b3aa958808049483a324.jpeg',
    },
  ];

  const categories = ['All', 'Bathroom', 'Heating', 'Plumbing'];
  const [selectedCategory, setSelectedCategory] = useState('All');

  const filteredProjects = selectedCategory === 'All' 
    ? projects 
    : projects.filter(project => project.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-primary text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
                Our Works
              </h1>
              <p className="text-lg sm:text-xl text-gray-300 leading-relaxed">
                Explore our portfolio of completed plumbing and heating projects across Kerry. Quality workmanship and satisfied customers are our pride.
              </p>
            </div>
          </div>
        </section>

        {/* Filter Section */}
        <section className="py-12 bg-gray-50 border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap gap-3 justify-center">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-2.5 rounded-full font-medium text-sm transition-all whitespace-nowrap ${
                    selectedCategory === category
                      ? 'bg-accent text-white shadow-md'
                      : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Projects Grid */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredProjects.map((project, index) => (
                <div
                  key={index}
                  className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer"
                >
                  <div className="aspect-[4/3] w-full h-full overflow-hidden">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6">
                    <span className="inline-block px-3 py-1 bg-accent/10 text-accent text-xs font-semibold rounded-full mb-3 whitespace-nowrap">
                      {project.category}
                    </span>
                    <h3 className="text-xl font-bold text-primary mb-2">
                      {project.title}
                    </h3>
                    <p className="text-gray-600 text-sm flex items-center">
                      <i className="ri-map-pin-line mr-2"></i>
                      {project.location}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-primary mb-6">
              Ready to Start Your Project?
            </h2>
            <p className="text-gray-600 text-lg mb-8">
              Contact us today for a free consultation and quote. Let's bring your vision to life!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/#contact"
                className="inline-flex items-center justify-center space-x-2 bg-accent hover:bg-accent-dark text-white px-8 py-4 rounded-lg font-medium transition-colors whitespace-nowrap"
              >
                <span>Get Free Quote</span>
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="tel:+353873719751"
                className="inline-flex items-center justify-center space-x-2 bg-white border-2 border-primary text-primary hover:bg-primary hover:text-white px-8 py-4 rounded-lg font-medium transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                <span>Call Now</span>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default OurWorksPage;